import { createSelector } from 'reselect'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectWelcomeFlowCheckedPartners = createSelector(
  [selectWelcomeFlowState],
  (state) => state.checkedPartners
)
